// Texty klientské sekce (customerPage.js, `/klient/*`). Regexy, kterými modul
// čte NATIVNÍ text Shoptetu (stavy objednávek, hlavičky tabulek, řádky tabulky
// slev), patří sem taky — SK dvojče musí sedět na slovenský text platformy.
import { plural } from '../plural.js';

export default {
  // Skupiny sidebaru (GROUPS)
  groupAccount: 'Účet',
  groupPurchases: 'Nákupy',
  groupDocs: 'Doklady',
  groupBenefits: 'Výhody a obsah',

  // Zkrácené popisky mobilních pilulek/dlaždic (NAV[].short)
  navHub: 'Přehled',
  navSettings: 'Osobní údaje',
  navShipping: 'Doručovací adresa',
  navOrders: 'Objednávky',
  navDocs: 'Daňové doklady',
  navProforma: 'Zálohové faktury',
  navCredit: 'Dobropisy',
  navDelivery: 'Dodací listy',
  navPayments: 'Doklady k platbě',
  navDiscounts: 'Slevy',
  navReviews: 'Hodnocení',
  navThreads: 'Diskuze',

  // Druhý řádek dlaždice rozcestníku (TILE_DESC)
  tileSettings: 'Kontakt, fakturační adresa a heslo.',
  tileShipping: 'Adresa, kam vám zboží doručíme.',
  tileOrders: 'Stav zásilky, historie a nákup znovu.',
  tileDocs: 'Faktury k dokončeným objednávkám v PDF.',
  tileProforma: 'Podklady k platbě předem.',
  tileCredit: 'Vrácené zboží a opravné doklady.',
  tileDelivery: 'Co přesně přišlo v které zásilce.',
  tilePayments: 'Potvrzení o zaplacení.',
  tileDiscounts: 'Cenová hladina a individuální slevy.',
  tileReviews: 'Recenze, které jste napsali.',
  tileThreads: 'Dotazy k produktům a odpovědi.',

  // Perex pod H1 (PEREX)
  perexHub: 'Objednávky, doklady, uložené údaje i slevy máte na jednom místě. Vyberte si sekci.',
  perexSettings:
    'Údaje se předplňují do košíku. E-mail i heslo měníte ve stejném formuláři, změnu potvrdíte současným heslem.',
  perexShipping: 'Adresa, na kterou vám zboží doručíme. Fakturační údaje se mění v osobních údajích.',
  perexOrders: 'Historie nákupů včetně stavu zásilky, dokladů a možnosti objednat totéž znovu.',
  perexDocs: 'Faktury k dokončeným objednávkám. Doklad si můžete kdykoli stáhnout v PDF.',
  perexProforma: 'Podklady k platbě předem. Po zaplacení dostanete běžný daňový doklad.',
  perexCredit: 'Opravné doklady k vrácenému nebo reklamovanému zboží.',
  perexDelivery: 'Co přesně přišlo v které zásilce.',
  perexPayments: 'Potvrzení o přijaté platbě k vašim objednávkám.',
  perexDiscounts: 'Slevy se počítají automaticky v košíku, nemusíte zadávat žádný kód.',
  perexReviews: 'Hodnocení, která jste napsali. Zveřejněná uvidí ostatní zákazníci u produktu.',
  perexThreads: 'Dotazy k produktům a odpovědi našeho týmu.',
  /** pozdrav před perexem rozcestníku: „Dobrý den, Jan. …" / „Dobrý den. …" */
  greeting: (firstName) => (firstName ? 'Dobrý den, ' + firstName + '. ' : 'Dobrý den. '),

  // Prázdné stavy (EMPTY)
  emptyOrdersTitle: 'Ještě jste u nás nenakoupili',
  emptyDocsTitle: 'Zatím tu není žádný doklad',
  emptyProformaTitle: 'Zatím tu není žádná zálohová faktura',
  emptyCreditTitle: 'Zatím tu není žádný dobropis',
  emptyDeliveryTitle: 'Zatím tu není žádný dodací list',
  emptyPaymentsTitle: 'Zatím tu není žádný doklad k platbě',
  emptyReviewsTitle: 'Zatím jste nenapsali žádné hodnocení',
  emptyThreadsTitle: 'Zatím jste nezaložili žádnou diskuzi',
  /** CTA prázdného stavu (výchozí i EMPTY.orders.cta — stejné znění) */
  emptyCta: 'Prohlédnout nabídku',

  // Zkratky pod prázdným stavem (SHORTCUTS)
  shortcutSale: 'Akční nabídky',
  shortcutClearance: 'Výprodej',
  shortcutBrands: 'Značky',

  eyebrow: 'Zákaznické centrum',
  supportTitle: 'Nesedí něco v objednávce?',
  supportText: 'Napište nebo zavolejte, máme přehled o všech vašich nákupech.',
  supportTextNoPhone: 'Napište nám, máme přehled o všech vašich nákupech.',
  saved: 'Uložené údaje',
  edit: 'Upravit',
  level: 'Vaše cenová hladina',
  levelCta: 'Kontaktovat obchodníka',
  b2bTitle: 'Kupujete pravidelně na firmu?',
  b2bText: 'Velkoobchodní odběratelé mají vlastní ceník, splatnost na fakturu a přednostní servis nářadí.',
  b2bCta: 'Podmínky B2B',
  all: 'Vše',

  /** badge zvýhodněného ceníku v hlavičce karty: „Zvýhodněný ceník · −20 %" */
  specialDiscount: (pct) => 'Zvýhodněný ceník · −' + pct + ' %',
  specialPlain: 'Zvýhodněný ceník',

  // Karta „Uložené údaje" (buildSaved)
  mailLabel: 'Přihlašovací e-mail',
  nameLabel: 'Jméno',
  shipTitle: 'Doručovací adresa',
  shipText: 'Kam vám zboží doručíme, když je jiná než fakturační.',

  /** panel cenové hladiny (buildLevel), fallback bez známé úrovně VO ceníku */
  fromPricelist: 'z ceníkových cen',

  /** počet záznamů pod pilulkovým filtrem: „5 záznamů" */
  recordsCount: (n) => n + ' ' + plural(n, ['záznam', 'záznamy', 'záznamů']),

  orderSearchPlaceholder: 'Číslo objednávky',
  orderSearchAria: 'Hledat číslo objednávky',

  /** fallback titulek karty nastavení, když sekce nemá nadpis */
  settingsFallback: 'Údaje',
  /** fallback titulek karty doručovacích údajů, když sekce nemá nadpis */
  shippingFallback: 'Doručovací adresa',

  // --- Regexy nad NATIVNÍM textem Shoptetu (STATUS_TONE, hlavičky tabulek,
  // řádky tabulky slev) — SK dvojče musí sedět na slovenský text platformy.
  /** stav objednávky/dokladu → tón pilulky (STATUS_TONE) */
  toneOffRe: /zrušen|storn/i,
  toneOkRe: /dokonč|vyříz|doruč|zaplac|uhraz/i,
  toneShipRe: /odes|expedov|přeprav|cestě|vyzvednut/i,
  toneWorkRe: /čeká|zpracov|přijat|nová|nezaplac|rezerv/i,
  /** hlavička tabulky = sloupec s částkou (NUM_RE) */
  numRe: /částk|cena|celkem|dph|sleva|hodnota/i,
  /** hlavička tabulky = sloupec s datem (DATE_RE) */
  dateRe: /vystaven|datum|vytvoř|splatnost|objednáno/i,
  /** hlavička tabulky = sloupec se stavem (STATUS_RE) */
  statusColRe: /^stav\b|status|zaplac/i,
  /** řádek nativní tabulky slev: „Zákaznická skupina" */
  discountGroupRe: /skupin/,
  /** řádek nativní tabulky slev: „Aktuální sleva" */
  discountValueRe: /aktuáln/,
};
